module.exports = __webpack_public_path__ + "static/media/choose-battle-online-challenge.62e63035.png";